import axios from 'axios';
import authToken from './authToken';
import cfac22 from '../cfac22';

export function createCommunicationMessage(payload) {
  return new Promise((resolve, reject) => {
    authToken().then((token) => {
      axios
        .post(
          cfac22('API_HOST_V2') +
            `/communicationMessages/create
            `,
          {
            ...payload,

            /* {
              "title": "teste do bidas",
              "message": "mensagem de teste do bidas",
              "partnerId": "-Kx8jpgL7X-e_aJf0R7B_clubmapfre",
              "scheduleDate": 1739902584173
          } */
          },
          {
            headers: { authorization: 'Bearer ' + token, 'Full-Url': window.location.href },
          }
        )
        .then((result) => {
          resolve(result.data.response);
        })
        .catch((error) => {
          return reject(error.response.data.error);
        });
    });
  });
}
